import dayjs from "dayjs";

import { formatProjectExpertiseCode } from "../../../entity/project";

import { CustomCheckboxFilter, CustomDateFilter, getDynamicMainMenuItems } from "./local-components";

import type { SearchDto } from "./projects-page.lib";

type TableColumn = {
  field: string;
  headerName: string;
  flex?: number;
  minWidth?: number;
  filter?: () => React.ReactNode;
  sortable?: boolean;
  filterParams?: { menuPopupPosition: string };
  mainMenuItems?: (params: Parameters<typeof getDynamicMainMenuItems>[0]) => ReturnType<typeof getDynamicMainMenuItems>;
  cellRenderer?: (params: { value: string | number }) => string;
};

export const getTableColumns = (
  searchValue: null | string,
  searchPatternState: SearchDto | Record<string, never>,
  setSearchPatternState: React.Dispatch<React.SetStateAction<SearchDto | Record<string, never>>>,
): TableColumn[] => [
  {
    field: "meta",
    headerName: "Номер проекта экспертизы",
    flex: 1,
    minWidth: 180,
    filter: () => (
      <CustomCheckboxFilter
        name="EXTERNAL_ID"
        searchValue={searchValue}
        searchPatternState={searchPatternState}
        setSearchPatternState={setSearchPatternState}
      />
    ),
    sortable: true,
    filterParams: {
      menuPopupPosition: "over",
    },
    mainMenuItems: (params: Parameters<typeof getDynamicMainMenuItems>[0]) => getDynamicMainMenuItems(params, "meta"),
    cellRenderer: (params: { value: string | number }) => formatProjectExpertiseCode(String(params.value || "")) || "-",
  },
  {
    field: "title",
    headerName: "Наименование проекта",
    flex: 2,
    minWidth: 240,
    filter: () => (
      <CustomCheckboxFilter
        name="TITLE"
        searchValue={searchValue}
        searchPatternState={searchPatternState}
        setSearchPatternState={setSearchPatternState}
      />
    ),
    sortable: true,
    filterParams: {
      menuPopupPosition: "over",
    },
    mainMenuItems: (params: Parameters<typeof getDynamicMainMenuItems>[0]) => getDynamicMainMenuItems(params, "title"),
  },
  {
    field: "objectName",
    headerName: "Организация",
    flex: 1,
    minWidth: 180,
    filter: () => (
      <CustomCheckboxFilter
        name="ORGANIZATION"
        searchValue={searchValue}
        searchPatternState={searchPatternState}
        setSearchPatternState={setSearchPatternState}
      />
    ),
    sortable: true,
    filterParams: {
      menuPopupPosition: "over",
    },
    mainMenuItems: (params: Parameters<typeof getDynamicMainMenuItems>[0]) => getDynamicMainMenuItems(params, "objectName"),
  },
  {
    field: "date",
    headerName: "Дата создания",
    flex: 1,
    minWidth: 160,
    filter: () => <CustomDateFilter searchPatternState={searchPatternState} setSearchPatternState={setSearchPatternState} />,
    sortable: true,
    cellRenderer: (params: { value: string | number }) => dayjs.unix(Number(params.value)).format("DD.MM.YYYY"),
    filterParams: {
      menuPopupPosition: "over",
    },
    mainMenuItems: (params: Parameters<typeof getDynamicMainMenuItems>[0]) => getDynamicMainMenuItems(params, "date"),
  },
];
